const TOPBAR = {
  AUTOCOMPLETE_PLACEHOLDER: 'O que você procura?',
  BUTTON_HIGH_OFFERS: 'Em alta',
  BUTTON_BLACK_FRIDAY: 'Black Friday',
  BUTTON_COMMENTS: 'Comentários',
  BUTTON_COUPONS_BY_STORE: 'Cupons por lojas',
  BUTTON_LAST_COUPONS: 'Últimos cupons',
  BUTTON_PROMOBIT_COUPONS: 'Cupons Promobit',
  BUTTON_STORE: 'Lojas',
  BUTTON_LOWEST_PRICE: 'Menor Preço',
  DROPDOWN_CATEGORY: 'Categorias',
  DROPDOWN_COUPONS_PER_STORE: 'Cupons por loja',
  DROPDOWN_TOPICS_PER_CATEGORY: 'Tópicos por categorias',
  GA_EVENT_CATEGORY: 'topbar',
  LOGIN_JOIN: 'Entre ou Cadastre-se',
  SHORT_LOGIN_JOIN: 'Entrar',
  MESSAGES: 'Mensagens',
  MY_OFFERS: 'Minhas ofertas',
  MY_PROFILE: 'Meu perfil',
  NIGHT_MODE: 'Modo noturno',
  SEND_FEEDBACK: 'Fale com o Promobit',
  SETTINGS: 'Configurações',
  SHOW_ALL_STORES: 'Ver todas as lojas',
  STORES: 'Lojas',
  SUGGEST_COUPON: 'Sugerir cupom',
  SUGGEST_OFFER: 'Sugerir oferta',
  SUGGEST_THREAD: 'Sugerir tópico',
  TOP: {
    MENU: {
      BLOG: 'Blog',
      COUPONS: 'Cupons',
      FORUM: 'Fórum',
      OFFERS: 'Ofertas',
      TRAVEL: 'Viagens',
    },
  },
  USER_LEVEL: 'Nível',
  USER_LOGOUT: 'Sair',
};

export default TOPBAR;
